function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "48pt",
    height: "48pt",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 28.351562 23.996094 L 43.613281 8.738281 C 44.816406 7.535156 44.816406 5.585938 43.613281 4.386719 C 42.410156 3.183594 40.464844 3.183594 39.261719 4.386719 L 23.996094 19.644531 L 8.738281 4.386719 C 7.535156 3.183594 5.589844 3.183594 4.386719 4.386719 C 3.183594 5.585938 3.183594 7.535156 4.386719 8.738281 L 19.644531 23.996094 L 4.386719 39.261719 C 3.183594 40.460938 3.183594 42.410156 4.386719 43.613281 C 4.984375 44.214844 5.773438 44.515625 6.5625 44.515625 C 7.347656 44.515625 8.136719 44.214844 8.738281 43.613281 L 23.996094 28.351562 L 39.261719 43.613281 C 39.863281 44.214844 40.648438 44.515625 41.4375 44.515625 C 42.222656 44.515625 43.011719 44.214844 43.613281 43.613281 C 44.816406 42.410156 44.816406 40.464844 43.613281 39.261719 Z M 28.351562 23.996094 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/Close.432f4a84c4a3c9aa97ca266c59d6a0b0.svg";
export { ForwardRef as ReactComponent };